import { useEffect, useState } from "react";

function calc(target) {
  const diff = new Date(target).getTime() - Date.now();
  if (diff <= 0) return null;
  return {
    days: Math.floor(diff / 86400000),
    hours: Math.floor((diff % 86400000) / 3600000),
    minutes: Math.floor((diff % 3600000) / 60000),
    seconds: Math.floor((diff % 60000) / 1000),
  };
}

const Unit = ({ value, label }) => (
  <div className="flex flex-col items-center" data-testid={`countdown-${label.toLowerCase()}`}>
    <div className="min-w-[64px] sm:min-w-[86px] rounded-2xl bg-espressoDeep/90 backdrop-blur px-3 py-4 sm:py-5 border border-white/10 shadow-lift">
      <span className="font-serif text-3xl sm:text-5xl text-goldLight tabular-nums">
        {String(value).padStart(2, "0")}
      </span>
    </div>
    <span className="mt-2 text-eyebrow text-white/60">{label}</span>
  </div>
);

export function Countdown({ target, light = false }) {
  const [t, setT] = useState(() => calc(target));

  useEffect(() => {
    const id = setInterval(() => setT(calc(target)), 1000);
    return () => clearInterval(id);
  }, [target]);

  if (!t) {
    return (
      <div className="text-center" data-testid="countdown-live">
        <p className={`font-serif text-2xl sm:text-3xl ${light ? "text-goldLight" : "text-espresso"}`}>
          The table is set — welcome to Friendsgiving 🥂
        </p>
      </div>
    );
  }

  return (
    <div className="flex items-end justify-center gap-3 sm:gap-5" data-testid="countdown">
      <Unit value={t.days} label="Days" />
      <Unit value={t.hours} label="Hours" />
      <Unit value={t.minutes} label="Minutes" />
      <Unit value={t.seconds} label="Seconds" />
    </div>
  );
}
